const initialState = {
    loading: false,
    error: null,
    message:null,
    webinarDetails:null,
    updatewebinarDetailserror:null,
    updateloading:null,
    webinarKeywordLoading:null,
    webinarKeywordError:null,
    webinarKeywords:null
}

const WebinarDetailReducer = (state = initialState, action) => {
    switch(action.type){
        
        case 'GET_HOME_WEBINARS_LIST_REQUEST':
            return{
                ...state,
                loading:true
            }
        case 'GET_HOME_WEBINARS_LIST_SUCCESS':
            return {
                ...state,
                loading:false,
                webinarDetails:action.payload,
            }
        case 'GET_HOME_WEBINARS_LIST_FAILURE':
            return {
                ...state,
                loading:false,
                error:action.payload,
            }  
        case 'GET_WEBINAR_KEYWORDS_REQUEST':
            return {
                ...state,
                webinarKeywordLoading:true,
            }
        case 'GET_WEBINAR_KEYWORDS_SUCCESS':
            return {
                ...state,
                webinarKeywordLoading:false,
                webinarKeywords:action.payload,
            }
        case 'GET_WEBINAR_KEYWORDS_FAILURE':
            return {
                ...state,
                webinarKeywordLoading:false,
                webinarKeywordError:action.payload,
            }
        case 'UPDATE_HOME_WEBINARS_LIST_REQUEST':
            return{
                ...state,
                updateloading:true
            }

        case 'UPDATE_HOME_WEBINARS_LIST_SUCCESS':
            let webinarDetailsList=state.webinarDetails
            if(action.payload){
                webinarDetailsList.data.results.push(...action.payload.data.results)
                webinarDetailsList.data.current=action.payload.data.current
                webinarDetailsList.data.itemsOnPage=action.payload.data.itemsOnPage
                webinarDetailsList.data.next=action.payload.data.next
                webinarDetailsList.data.previous=action.payload.data.previous
            }
            return {
                    ...state,
                    updateloading:false,
                    webinarDetails:webinarDetailsList,
                }
        case 'UPDATE_HOME_WEBINARS_LIST_FAILURE':
            return {
                ...state,
                updateloading:false,
                updatewebinarDetailserror:action.payload,
            }      

        default: return state
    }
}

export default WebinarDetailReducer